import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import Loader from '@rsos/components/capstone/Loader/Loader';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import { gspx } from '@rsos/gainsight';
import { setAdrQueryStatus } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { useSelectedCall } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import { NoData } from './AdrQueryContainer.styles';

const trackButtonClick = () => {
  gspx.trackCustomEvent('ADR', {
    category: 'ADR',
    name: 'User clicks on ADR Query button',
  });
};

const RequestAdr = () => {
  const selectedCall = useSelectedCall();
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );
  const dispatch = useDispatch();

  const adrQueryData = selectedCall?.adrQuery;

  const isFetched = adrQueryData.fetched;
  const isLoading = adrQueryData.loading;
  const hasData = adrQueryData?.hasData;

  /**
   * Function to update the loading status for the adr query to trigger a Hermes
   * subscription
   */
  const handleClick = useCallback(() => {
    dispatch(
      setAdrQueryStatus({
        callerID: selectedCallerID,
        loading: true,
        fetched: false,
      }),
    );
    trackButtonClick();
  }, [dispatch, selectedCallerID]);

  if (!hasData) {
    return (
      <>
        <Box width="100%" mb="16px">
          <Button grow onClick={handleClick} disabled={isLoading} noMargin>
            Check for Additional Apple Data
          </Button>
        </Box>
        {isLoading && (
          <Box width="100%" horizontal justify="center">
            <Loader />
          </Box>
        )}
        {isFetched && (
          <NoData horizontal px="12px" py="20px">
            <Box pr="12px" justify="center">
              <AttentionTriangleIcon />
            </Box>
            <Text size="normal">
              Failed to retrieve additional data. Click the above button to try
              again
            </Text>
          </NoData>
        )}
      </>
    );
  }
  return null;
};

export default RequestAdr;
